import React from 'react'
import { AuthProvider } from '@/core/auth/AuthContext'
import { QueryProvider } from './QueryProvider'
import { SocketProvider } from '@/contexts/SocketContext'
import { NotificationProvider } from './NotificationProvider'

interface AppProviderProps {
  children: React.ReactNode
}

/**
 * Combined provider wrapper for all app-level providers
 * This ensures proper provider nesting order
 */
export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return (
    <QueryProvider>
      <AuthProvider>
        <SocketProvider>
          <NotificationProvider>
            {children}
          </NotificationProvider>
        </SocketProvider>
      </AuthProvider>
    </QueryProvider>
  )
}